var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RequestIntersectionsWithCollisionShapeMessage, RequestRaycastClosestIntersectionMessage, ResponseIntersectionsWithPrimitiveCollisionShapeMessage, ResponseRaycastClosestIntersectionMessage } from "@messages/selection";
import { busService } from "../../bus";
import { convertToNumber3 } from "flavr-common";
import { BooleanMeshIntersectionRequestMessage, BooleanMeshIntersectionResponseMessage } from "@messages/booleanMeshOperation/BooleanMeshIntersectionMessages";
const busConnection = busService.connection("ScriptCollision");
export class ScriptRaycaster {
    /**
     * Perform a raycast with all models that have a CollisionFacet and are selectable. If params with targetModelUIDs
     * are specified then the raycast is only performed against the specified models if they have CollisionFacets.
     * @param origin
     * @param direction
     * @param params
     */
    static raycast(origin, direction, params) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            params = Object.assign({ backfaceCulling: false }, params);
            const response = yield busConnection.askByMessageType(new RequestRaycastClosestIntersectionMessage(convertToNumber3(origin), convertToNumber3(direction), params), ResponseRaycastClosestIntersectionMessage);
            const result = response.response;
            if (result === undefined) {
                return undefined;
            }
            const normalizedResult = {
                uid: result.uid,
                distance: result.distance,
                worldPosition: (_a = result.worldPosition) !== null && _a !== void 0 ? _a : [0, 0, 0],
                localPosition: (_b = result.localPosition) !== null && _b !== void 0 ? _b : [0, 0, 0],
                worldNormal: (_c = result.worldNormal) !== null && _c !== void 0 ? _c : [0, 1, 0],
                localNormal: (_d = result.localNormal) !== null && _d !== void 0 ? _d : [0, 1, 0],
            };
            if (result.worldPosition === undefined ||
                result.localPosition === undefined ||
                result.worldNormal === undefined ||
                result.localNormal === undefined) {
                console.warn("[script] Received incomplete raycast result, normalizing before exposing it to scripts", result);
            }
            return normalizedResult;
        });
    }
    /**
     * Request the uids of all target models that intersect with the test model. In order for the intersection to work,
     * each of these models needs to have a CollisionFacet otherwise these models will be ignored. If one or more uids
     * are provided then the test model is tested against all of them regardless if they are enabled or disabled. If no
     * target models are specified then the test model is tested against all other models with CollisionFacets (with the
     * exception being the test model itself)
     * @param testModelUid
     * @param targetModelUids
     */
    static intersect(testModelUid, targetModelUids) {
        return __awaiter(this, void 0, void 0, function* () {
            if (testModelUid === undefined)
                return [];
            if (typeof targetModelUids === "number")
                targetModelUids = [targetModelUids];
            const request = new RequestIntersectionsWithCollisionShapeMessage(testModelUid, targetModelUids);
            const response = yield busConnection.askByMessageType(request, ResponseIntersectionsWithPrimitiveCollisionShapeMessage);
            return Array.from(response.selectables).map((result) => result.uid);
        });
    }
    /**
     * Checks if two models specified by uid intersect each other
     * @param mesh1Uid
     * @param mesh2Uid
     */
    static intersectMeshes(mesh1Uid, mesh2Uid) {
        return __awaiter(this, void 0, void 0, function* () {
            if (mesh1Uid === undefined || mesh2Uid === undefined) {
                return false;
            }
            const response = yield busConnection.askByMessageType(new BooleanMeshIntersectionRequestMessage(mesh1Uid, mesh2Uid), BooleanMeshIntersectionResponseMessage);
            return response.intersected;
        });
    }
}
